import {
  superadminDeleteCompany,
  superadminDeleteCompanyDocuments,
} from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";

const DocumentModalDelete = ({
  show,
  onCloseClick,
  getData,
  data,
  setData,
}: any) => {
  const handleDelete = async () => {
    superadminDeleteCompanyDocuments(data._id)
      .then((response: any) => {
        onCloseClick();
        getData();
        setData();
        toast.success(
          <div>
            Berkas <b>{data?.documentType}</b> berhasil dihapus!
          </div>,
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (!show) {
      setData();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i className="ri-delete-bin-line display-5 text-danger"></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Anda Yakin ?</h4>
            <p className="text-muted mx-2 mb-0">
              Apakah anda yakin untuk menghapus data berkas{" "}
              <b>{data?.documentType}</b> ?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="button"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
            onClick={() => handleDelete()}
          >
            Hapus
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DocumentModalDelete.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.any,
  setData: PropTypes.func,
};

export default DocumentModalDelete;
